// ONE PLACE THAT KNOWS WHICH COLUMN A SCALE READS.
//
// Before the Prince and Princess scales arrived this was eight copies of
// `scale === "king" ? node.colorKingHex : node.colorQueenHex` spread over six
// files, and the paths had a ternary of their own pointing the other way. Four
// scales plus the Minutum Mundum would have made every one of those a
// four-branch switch, and the Minutum Mundum — which reads the Queen column for
// a sphere and the King column for a path — could not have been written as a
// branch of either.
//
// So the payload carries the ANSWER. Each descriptor says which column the
// spheres read and which the paths read, straight off `ColorScales` in Ruby,
// and everything here is a lookup. A sixth scale is a seed-side decision and
// no edit at all on this side.

const COLUMN_KEYS = {
  king: { name: "colorKing", hex: "colorKingHex" },
  queen: { name: "colorQueen", hex: "colorQueenHex" },
  prince: { name: "colorPrince", hex: "colorPrinceHex" },
  princess: { name: "colorPrincess", hex: "colorPrincessHex" }
};

// The pairing this site has always drawn, as a last resort for a payload that
// carries no descriptors at all — a fixture, or a tradition with no scales.
const FALLBACK = { slug: "minutum_mundum", spheres: "queen", paths: "king" };

export function findScale(scales, slug) {
  if (!scales || scales.length === 0) return FALLBACK;
  return scales.find((scale) => scale.slug === slug) || scales[0];
}

function column(scale, side) {
  const key = (scale && scale[side]) || FALLBACK[side];
  return COLUMN_KEYS[key] || COLUMN_KEYS[FALLBACK[side]];
}

// The hex a sphere is drawn in, or null where this tradition has no scales and
// the neutral fill takes over. Never a default colour: the caller owns that,
// because a sphere falls back to `colorHex` and a path does not.
export function sphereHex(sephirah, scale) {
  return sephirah[column(scale, "spheres").hex] || null;
}

export function sphereName(sephirah, scale) {
  return sephirah[column(scale, "spheres").name] || null;
}

export function pathHex(path, scale) {
  return path[column(scale, "paths").hex] || path.colorKingHex || null;
}

export function pathName(path, scale) {
  return path[column(scale, "paths").name] || null;
}

// MALKUTH'S FOUR QUARTERS BELONG TO THE QUEEN COLUMN AND TO NOTHING ELSE.
// `color_queen_quadrants` is the one cell in the table that is four colours,
// and the other three scales each give that row a single colour of its own —
// so quartering it under them would be this site drawing a cell 777 does not
// print. It is why the quadrants are asked for by COLUMN here rather than by
// "is this the quartered sphere".
export function sphereQuadrants(sephirah, scale) {
  if (column(scale, "spheres") !== COLUMN_KEYS.queen) return [];
  return sephirah.colorQueenQuadrants || [];
}
